var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97439 0.682503C9.80939 0.688138 9.65052 0.746391 9.52099 0.848751L2.18894 6.62512C1.25836 7.3585 0.713867 8.47915 0.713867 9.66393V19.5119C0.713867 20.2153 1.30011 20.8015 2.00355 20.8015H7.16228C7.86572 20.8015 8.45196 20.2153 8.45196 19.5119V14.3531C8.45196 14.2009 8.55769 14.0952 8.7099 14.0952H11.2893C11.4415 14.0952 11.5472 14.2009 11.5472 14.3531V19.5119C11.5472 20.2153 12.1334 20.8015 12.8369 20.8015H17.9956C18.6991 20.8015 19.2853 20.2153 19.2853 19.5119V9.66393C19.2853 8.47915 18.7408 7.3585 17.8102 6.62512L10.4782 0.848751C10.3351 0.735711 10.1567 0.676833 9.97439 0.682503ZM9.99958 2.44171L16.853 7.84125C17.4123 8.28199 17.7377 8.95236 17.7377 9.66393V19.2539H13.0948V14.3531C13.0948 13.3653 12.2771 12.5476 11.2893 12.5476H8.7099C7.72203 12.5476 6.90434 13.3653 6.90434 14.3531V19.2539H2.26149V9.66393C2.26149 8.95236 2.58687 8.28199 3.14613 7.84125L9.99958 2.44171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/Home-icon.fc8fb8e48c06cdb851b6553949384abf.svg";
export { ForwardRef as ReactComponent };